<ng-container *ngIf="showListPost || showStickyPost">
  <div class="container">
    <div class="title-lg text-center">{{ data?.title }}</div>
    <app-sticky-post #sticky *ngIf="showStickyPost" [post]="stickyPost"></app-sticky-post>
  </div>

  <app-post-carousel #carousel *ngIf="showListPost" [listPost]="listPost"></app-post-carousel>
</ng-container>
